import { useCallback, useState } from 'react';
import z from 'zod';

const schema = z.object({
  email: z.string().email(),
});

type LastAuthMethod = 'email' | 'google';

interface State {
  email?: string;
  isReturningUser?: boolean;
  lastAuthMethod?: LastAuthMethod;
}

const getInitialState = (): State => {
  // During SSR, localStorage is not available
  if (typeof window === 'undefined') {
    return {
      isReturningUser: undefined,
      email: undefined,
      lastAuthMethod: undefined,
    };
  }

  return resolveState();
};

const resolveState = (): State => {
  const quickLogin = localStorage.getItem('quick_login');
  if (quickLogin) {
    const email = schema.safeParse({ email: quickLogin }).data?.email;
    if (email) {
      return { isReturningUser: true, email, lastAuthMethod: 'email' };
    }
  }

  if (localStorage.getItem('is_google_user') === '1') {
    return {
      isReturningUser: true,
      email: undefined,
      lastAuthMethod: 'google',
    };
  }

  return {
    isReturningUser: false,
    email: undefined,
    lastAuthMethod: undefined,
  };
};

export const useReturningUser = () => {
  const [state, setState] = useState<State>(getInitialState);

  const revalidate = useCallback(() => {
    setState(resolveState());
  }, []);

  return { data: state, revalidate };
};
